/** Overview page copy. */
export const pagesOverviewSv = {
    title: 'Överblick',
    numberOfIssues: 'Antal emissioner',
    numberOfListedWarrants: 'Antal noterade optioner',
    ongoingAndUpcoming: 'Pågående och kommande',
    ongoingAndUpcomingWarrants: 'Pågående och kommande emissioner och teckningsoptioner',
    latest20RightsIssues: 'Senaste 20 företrädesemissionerna',
    numberOfFutureAndOngoingRightsIssues: 'Antal pågående och kommande företrädesemissioner',
    averageTotalCommitment: 'Genomsnittlig säkerställandegrad de senaste 20 emissionerna',
    averageOutcomeExclGuarantors: 'Genomsnittligt utfall de senaste 20 emissionerna',
    recentlyAnnouncedIssues: 'Senaste aviserade emissionerna',
    recentlyCompletedRightsIssues: 'Senaste avslutade företrädesemissioner',
    statsShort: {
        numberOfIssues: 'emissioner',
        numberOfListedWarrants: 'noterade optioner',
    },
}
